module.exports = __webpack_public_path__ + "static/media/logoSpinner.1715d173.png";